// ============================================================================
// NOTIFICATIONS SERVICE
// ============================================================================

import { api } from './api';

export type NotificationType =
  | 'stale_project'
  | 'stale_session'
  | 'weekly_cost_summary'
  | 'platform_update'
  | 'data_retention_request'
  | 'project_shared'
  | 'session_completed';

export interface Notification {
  notificationId: string;
  type: NotificationType;
  title: string;
  message: string;
  userId?: string;
  organizationId?: string;
  linkUrl?: string;
  retentionAction?: {
    targetType: 'project' | 'session';
    targetId: string;
    targetName: string;
  };
  actionTaken?: 'ignored' | 'purged';
  actionTakenAt?: string;
  read: boolean;
  readAt?: string;
  createdAt: string;
}

export async function getNotifications(): Promise<Notification[]> {
  const response = await api.get('/api/notifications');
  return response.data.notifications;
}

export async function markRead(notificationId: string): Promise<void> {
  await api.patch(`/api/notifications/${notificationId}/read`);
}

export async function takeAction(notificationId: string, action: 'ignored' | 'purged'): Promise<void> {
  await api.post(`/api/notifications/${notificationId}/action`, { action });
}

export async function broadcastPlatformUpdate(title: string, message: string, linkUrl?: string): Promise<void> {
  await api.post('/api/notifications/broadcast', { title, message, linkUrl });
}
